<template>
  <div class="left">
    <input type="checkbox" :id="For" name="level" v-model="checked" />
    <label class="checkbox01" :for="For">
      <span>{{ CheckBox }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "CheckBox",
  props: {
    CheckBox: {
      type: String,
      default: "チェックボックス",
    },
    For: {
      type: String,
      default: "test",
    },
    ischecked: {
      type: Boolean,
    },
  },
  computed: {
    checked: {
      get() {
        return this.$props.ischecked;
      },
      set(value) {
        this.$emit("change", { ischecked: value, checkboxName: this.CheckBox });
      },
    },
  },
};
</script>

<style scoped>
input[type="checkbox"] {
  display: none;
}
.checkbox01 {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  padding: 5px 40px;
  position: relative;
  width: auto;
  font-size: 20px;
}
.checkbox01::before {
  background: #fff;
  border: 2px solid #696773;
  content: "";
  display: block;
  height: 21px;
  left: 5px;
  margin-top: -8px;
  position: absolute;
  top: 50%;
  width: 21px;
}
.checkbox01::after {
  border-right: 4px solid #77a88d;
  border-bottom: 4px solid #77a88d;
  content: "";
  display: block;
  height: 12px;
  left: 12px;
  margin-top: -7px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
  width: 5px;
}
input[type="checkbox"]:checked + .checkbox01::after {
  opacity: 1;
}
.left {
  padding-left: 15%;
  text-align: start;
}
@media screen and (max-width: 480px) {
  /* 480px以下に適用されるCSS（スマホ用） */
  .left {
    padding-left: 3%;
    text-align: left;
  }
}
</style>
